import { ArrowLeft } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

/* Le lien de retour, qui revient vraiment d'où l'on vient.
 *
 * ── Le défaut qu'il corrige ─────────────────────────────────────────────────
 *
 * Un écran de détail portait jusqu'ici un lien FIXE vers son parent
 * « naturel » — « ← Entraînement » sur le bilan d'une séance. Cela vaut quand
 * on y arrive par le menu ; cela trompe dès qu'on y arrive d'ailleurs. Ouvert
 * depuis les statistiques, le bilan renvoyait au catalogue d'exercices : le
 * lecteur perdait sa page, son onglet et sa position, pour un écran qu'il
 * n'avait pas demandé.
 *
 * ── Comment il sait ─────────────────────────────────────────────────────────
 *
 * L'écran qui MÈNE ici dit d'où il vient, dans l'état de navigation. Pas
 * `navigate(-1)` : l'historique du navigateur contient aussi les pages d'avant
 * l'application, et reculer d'un cran depuis un lien partagé fait sortir. Pas
 * un référent deviné non plus — le nom du bouton doit être vrai, et seule la
 * page de départ sait comment elle s'appelle.
 *
 * Sans provenance — lien partagé, page rechargée, arrivée par le menu — le
 * parent naturel reprend sa place. C'est le bon repli : il mène toujours
 * quelque part de sensé.
 */

export interface Provenance {
    /** Où revenir. */
    to: string;
    /** Comment s'appelle cet endroit, écrit sur le bouton. */
    label: string;
    /** Ce que la page de destination attend, s'il y a lieu — l'onglet ouvert,
     *  par exemple. */
    state?: unknown;
}

export function Retour({ defaut }: { defaut: Provenance }) {
    const location = useLocation();
    const venu = (location.state as { retour?: Provenance } | null)?.retour;
    const cible = venu ?? defaut;
    return (
        <Link to={cible.to} state={cible.state} className="btn btn-ghost btn-sm mb-2 gap-2">
            <ArrowLeft size={16} /> {cible.label}
        </Link>
    );
}
